<div
  id="status-details"
  class="col bg-white u-shadow">
  <!-- <div class="o-tech-table__header">{{ 'toolstatus.currentstatus' | translate }}</div> -->
  <div class="o-tech-table__container">
    <status-timeline [tool]="tool"></status-timeline>
    <table class="o-tech-table">
      <tbody>
        <!-- <tr class="o-tech-table__item o-tech-table">
                    <td scope="row" class="o-tech-table__title">{{ 'toolstatus.status' | translate }}</td>
                     <td scope="row" class="o-tech-table__title"></td>
                    <td scope="row"  class="o-tech-table__description">
                        <status-timeline [tool]="tool"></status-timeline>
                    </td>
                </tr> -->
        <tr class="o-tech-table__item">
          <td
            scope="row"
            class="o-tech-table__title">
            {{ "toolstatus.workorder" | translate }}
          </td>
          <td class="o-tech-table__description">{{ tool.jobNumber }}</td>
        </tr>
        <tr
          *ngIf="toolShipping"
          class="o-tech-table__item">
          <td
            scope="row"
            class="o-tech-table__title">
            {{ "toolstatus.trackingstatus" | translate }}
          </td>
          <td class="o-tech-table__description">
            <a
              *ngIf="showTrackingLink()"
              href="{{ toolShipping.trackingLink }}"
              target="_blank"
              >{{ toolShipping.trackingNumber }}</a
            >
            <span *ngIf="!showTrackingLink()">{{ tool.lastTrackingNumber }}</span>
          </td>
        </tr>
        <tr
          *ngIf="toolShipping?.shippingLabelLink"
          class="o-tech-table__item">
          <td
            scope="row"
            class="o-tech-table__title">
            {{ localizationConstants.TOOL_STATUS_LAST_SHIPPING_LABEL_TO_DOWNLOAD | translate }}
          </td>
          <td class="o-tech-table__description">
            <a [href]="toolShipping.shippingLabelLink">{{
              localizationConstants.TOOL_STATUS_LAST_SHIPPPING_LABEL_LINK | translate
            }}</a>
          </td>
        </tr>
        <tr class="o-tech-table__item">
          <td
            scope="row"
            class="o-tech-table__title">
            {{ "toolstatus.purchaseorder" | translate }}
          </td>
          <td class="o-tech-table__description">{{ tool.poNumber }}</td>
        </tr>
        <tr class="o-tech-table__item">
          <td
            scope="row"
            class="o-tech-table__title">
            {{ "toolstatus.lastupdated" | translate }}
          </td>
          <td class="o-tech-table__description">
            {{ tool.lastModifiedDate | date }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
